import { ResponseError, SocialApiResponse } from "@/lib/definitions";
import { toast } from "sonner";
import useSWR, { SWRConfiguration } from "swr";
import { socialCheck } from "../api/social/social.util";

function useSocialUpdates(ytid: string, noError?: boolean, asTag?: boolean) {
    const url = asTag ? ytid : ("youtube.com/channel/" + ytid);
    return useSWR<SocialApiResponse | ResponseError>(ytid && `channel/${ytid}` || null,
        {
            fetcher: async () => await socialCheck(url),
            refreshInterval: 1000 * 600, //revalidate each 10 min (10 * 60 * 1000),
            "onError": () => noError || toast.warning("טעינת מידע מערוץ יוטיוב נכשלה"), //change error message to not give info
            "onLoadingSlow": () => { }, //removed default slow load toast
            "revalidateOnFocus": true,
            "focusThrottleInterval": 2 * 60 * 1000, //when re-focus check again if 2 min has passed
        } as SWRConfiguration)

}
export default useSocialUpdates